import Modal from '../Modal/Modal';
import EditorButton from '../editor/EditorButton/EditorButton';
import type { ReactNode } from 'react';

interface NewExperimentModalProps {
  isModalVisible: boolean;
  onHandleContinue: () => void;
  onHandleContinueWithoutSaving: () => void;
  onClose: () => void;
  body?: ReactNode;
  children?: ReactNode;
}

export default function NewExperimentModal({
  isModalVisible,
  onHandleContinue,
  onHandleContinueWithoutSaving,
  onClose,
  body,
  children
}: NewExperimentModalProps) {
  return (
    <Modal
      title="Save modifications"
      isVisible={isModalVisible}
      onClose={onClose}
      body={body ?? children}
      footer={
        <>
          <EditorButton kind="none" onClick={onHandleContinueWithoutSaving}>
            Continue without exporting
          </EditorButton>
          <EditorButton kind="action" onClick={onHandleContinue}>
            Export
          </EditorButton>
        </>
      }
    />
  );
}
